import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { TRIGGER as POPOVER_TRIGGER } from '@snack-uikit/popover-private';
export var SIZE = {
  S: 's',
  Xs: 'xs'
};
export var SIZES_MAP = _defineProperty(_defineProperty({}, SIZE.Xs, 16), SIZE.S, 24);
export var TRIGGER = {
  Hover: 'hover',
  Click: 'click'
};
export var TRIGGER_MAP = _defineProperty(_defineProperty({}, TRIGGER.Hover, POPOVER_TRIGGER.HoverAndFocusVisible), TRIGGER.Click, POPOVER_TRIGGER.ClickAndFocusVisible);